<template>
  <v-dialog v-model="statisticArticleDialog" width="1200">
    <v-card>
      <!--Country and closebar-->
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <!--Country name-->
         <p class="pr-5 text--primary display-1 pt-5" v-if="item.countries !== 'null'">
          {{item.countries}}
        </p>
        <p class="pr-5 text--primary display-1 pt-5" v-else>
          Country not specified: {{item.countries}}
        </p>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!--Statistic Data-->
        <v-row class="ma-0 pa-0 pt-3">
          <v-col class="ma-0 pa-0">
            <v-hover>
              <v-card elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`" height="100%" class="pa-3">
                <p class="title ma-0 pa-0 pb-2">Article numbers</p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Total Articles:</span>
                  <span class="font-weight-bold pl-1">{{item.TotalArticles}}</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles today:</span>
                  <span class="font-weight-bold pl-1">{{item.NewArticlesDay}}</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles this week:</span>
                  <span class="font-weight-bold pl-1">{{item.NewArticlesWeek}}</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles this month:</span>
                  <span class="font-weight-bold pl-1">{{item.NewArticlesMonth}}</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles this year:</span>
                  <span class="font-weight-bold pl-1">{{item.NewArticlesYear}}</span>
                </p>
              </v-card>
            </v-hover>
          </v-col>
          <v-col class="ma-0 pa-0">
            <v-hover>
              <v-card elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`" height="100%" class="pa-3">
                <p class="title ma-0 pa-0 pb-2">Article settings</p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles with comment enabled:</span>
                  <span class="font-weight-bold pl-1">{{item.ArticlesWithCommentsEnabled}}</span>
                  <span class="pl-2">({{percentageCalculation.PercentageArticlesCommentsON.toFixed(1)}} %)</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles with comment disabled:</span>
                  <span class="font-weight-bold pl-1">{{item.ArticlesWithCommentsDisabled}}</span>
                  <span class="pl-2">({{percentageCalculation.PercentageArticlesCommentsOFF.toFixed(1)}} %)</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Total Comments on articles:</span>
                  <span class="font-weight-bold pl-1">{{item.TotalArticleComments}}</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles that are published:</span>
                  <span class="font-weight-bold pl-1">{{item.ArticlesThatArePublished}}</span>
                  <span class="pl-2">({{percentageCalculation.PercentageArticlesPublishON.toFixed(1)}} %)</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles that are unpublished:</span>
                  <span class="font-weight-bold pl-1">{{item.ArticlesThatAreNotPublished}}</span>
                  <span class="pl-2">({{percentageCalculation.PercentageArticlesPublishOFF.toFixed(1)}} %)</span>
                </p>
              </v-card>
            </v-hover>
          </v-col>
          <v-col class="ma-0 pa-0">
            <v-hover>
              <v-card elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`" height="100%" class="pa-3">
                <p class="title ma-0 pa-0 pb-2">More data</p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Total RSS articles:</span>
                  <span class="font-weight-bold pl-1">{{item.ArticleTypeRSS}}</span>
                  <span class="pl-2">({{percentageCalculation.PercentageArticleTypeRSS.toFixed(1)}} %)</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Total WeNewz articles:</span>
                  <span class="font-weight-bold pl-1">{{item.ArticleTypeArticle}}</span>
                  <span class="pl-2">({{percentageCalculation.PercentageArticleTypeArticle.toFixed(1)}} %)</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles written by males:</span>
                  <span class="font-weight-bold pl-1">{{item.ArticlesWrittenByMales}} </span>
                  <span class="pl-2">({{percentageCalculation.PercentageMaleArticleWriters.toFixed(1)}} %)</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Article written by females:</span>
                  <span class="font-weight-bold pl-1">{{item.ArticlesWrittenByFemales}}</span>
                  <span class="pl-2">({{percentageCalculation.PercentageFemaleArticleWriters.toFixed(1)}} %)</span>
                </p>
                <p class="subtitle-1 ma-0 pa-0">
                  <span>Articles that are reported:</span>
                  <span class="font-weight-bold pl-1">{{item.ArticlesReported}}</span>
                </p>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <!--Graph-->
        <v-row>
          <v-col>
            <v-card class="mx-auto text-center" color="blue lighten-3"  max-width="600">
              <v-card-text>
                <p class="display-1">
                  <span>Total Articles</span>
                  <span class="font-weight-bold pl-3">{{item.TotalArticles}}</span>
                </p>
                <v-sheet color="blue lighten-4">
                  <v-sparkline :value="item.ArticleGraph" color="red" height="100" padding="24" stroke-linecap="round" smooth>
                    
                  </v-sparkline>
                </v-sheet>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data(){
    return{
      statisticArticleDialog:false,
      item: {}
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog(item) {
      this.item = item;
      this.statisticArticleDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.statisticArticleDialog = false;
    }
  },
  computed:{
    // To display how many % within one value
    percentageCalculation(){
      // Variables to use in the equation
      let TotalAmountOfArticles = this.item.TotalArticles;
      let TotalArticlesWrittenByMales = this.item.ArticlesWrittenByMales;
      let TotalArticlesWrittenByFemales = this.item.ArticlesWrittenByFemales;
      let TotalArticleTypeRSS = this.item.ArticleTypeRSS;
      let TotalArticleTypeArticle = this.item.ArticleTypeArticle;
      let TotalArticleWithComments = this.item.ArticlesWithCommentsEnabled;
      let TotalArticleWithoutComments = this.item.ArticlesWithCommentsDisabled;
      let TotalArticlePublished = this.item.ArticlesThatArePublished;
      let TotalArticleNotPublished = this.item.ArticlesThatAreNotPublished;

      // Percentage calculation

      // Genders
      let PercentageMaleArticleWriters = TotalArticlesWrittenByMales * 100 / TotalAmountOfArticles;
      let PercentageFemaleArticleWriters = TotalArticlesWrittenByFemales * 100 / TotalAmountOfArticles;
      // Article Type
      let PercentageArticleTypeRSS = TotalArticleTypeRSS * 100 / TotalAmountOfArticles;
      let PercentageArticleTypeArticle = TotalArticleTypeArticle * 100 / TotalAmountOfArticles;
      // Articles with / without comments
      let PercentageArticlesCommentsON = TotalArticleWithComments * 100 / TotalAmountOfArticles;
      let PercentageArticlesCommentsOFF = TotalArticleWithoutComments * 100 / TotalAmountOfArticles;
      // Article that got publish on / off
      let PercentageArticlesPublishON = TotalArticlePublished * 100 / TotalAmountOfArticles;
      let PercentageArticlesPublishOFF = TotalArticleNotPublished * 100 / TotalAmountOfArticles;



      return { PercentageFemaleArticleWriters, PercentageMaleArticleWriters, PercentageArticleTypeRSS, PercentageArticleTypeArticle, PercentageArticlesCommentsON, PercentageArticlesCommentsOFF, PercentageArticlesPublishON, PercentageArticlesPublishOFF}
    }
  }
}
</script>